import { z } from 'zod'
import { occasionIdSchema } from '@/schemas/occasion.schema'

export const catalogSearchSchema = z.object({
  ocasiao: occasionIdSchema.optional(),
})

export type CatalogSearch = z.infer<typeof catalogSearchSchema>
